import {z} from "zod/v4-mini"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {
    curveGeometryAttributeSetLikeMarker,
    curveGeometryAttributeSetLike,
    meshGeometryAttributeSetLike,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {curveGeometryAttributeLike, meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode, MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeSetLikeNode, CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ProjectOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/project-operator/geometry-project-operator-node"
import {
    GeometryProjectOperatorNode,
    projectOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/project-operator/geometry-project-operator-node"

export type CurveGeometryProjectOperatorParameters = ProjectOperatorParameters<
    CurveGeometryAttributeLikeNode,
    CurveGeometryAttributeLikeNode | MeshGeometryAttributeLikeNode,
    CurveGeometryAttributeSetLikeNode | MeshGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<CurveGeometryProjectOperatorParameters> = {
    nodeClass: "CurveGeometryProjectOperator",
    validation: {
        parameters: projectOperatorParametersSchema(
            curveGeometryAttributeLike,
            z.union([curveGeometryAttributeLike, meshGeometryAttributeLike]),
            z.union([curveGeometryAttributeSetLike, meshGeometryAttributeSetLike]),
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryProjectOperator
    extends GeometryProjectOperatorNode<
        1,
        CurveGeometryAttributeLikeNode,
        CurveGeometryAttributeLikeNode | MeshGeometryAttributeLikeNode,
        CurveGeometryAttributeSetLikeNode | MeshGeometryAttributeSetLikeNode
    >
    implements CurveGeometryAttributeSetLikeNode
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
